export interface Store {
    id: string;
    name: string;
    logoUrl: string;
    metaKeywords: string[];
    code: string;
    description: string;
    favorite_color?:string;
}
